import {Component, OnInit} from '@angular/core';
import {StorageService} from '../../Services/storage.service';
import {DataService} from '../../Services/data.service';
import {NotificationService} from '../../Services/notification.service';
import {EncrDecrService} from '../../Services/encr-decr.service';

@Component({
  selector: 'app-quick-link',
  templateUrl: './quick-link.component.html',
  styleUrls: ['./quick-link.component.css'],
  standalone: false
})
export class QuickLinkComponent implements OnInit {

  permissionsAdmin = true;
  showAllLinks = false;
  vm: any = {};

  constructor(
    private localStorage: StorageService,
    private tableDataService: DataService,
    private notification: NotificationService,
    private crypt: EncrDecrService) {
  }

  ngOnInit() {
    this.vm.Preferences = JSON.parse(this.localStorage.StorageGet('Preferences'));
    this.vm.permissions = JSON.parse(this.localStorage.StorageGet('Permissions', ''));
    if (this.vm.Preferences.QuickLinks) {
      this.vm.quickLinks = this.vm.Preferences.QuickLinks;
    }
  }

  updateQuickLinks() {
    this.tableDataService.patch('Preferences/quicklinks', '', this.vm.Preferences.QuickLinks)
      .then((item: any) => {
        this.showAllLinks = false;
        this.vm.buttonsDisabled = false;
        this.localStorage.StorageSet('Preferences', this.crypt.encrypt(JSON.stringify(this.vm.Preferences)));
      }, (er: any) => {
        this.vm.buttonsDisabled = false;
        this.notification.error($localize`:errorSavingQuickLinks @@errorSavingQuickLinks:Error Saving Quick Links`);
      });
  }

  showLinksToEdit() {
    this.showAllLinks = false;
    this.vm.buttonsDisabled = true;
  }

}
